import { Component, OnInit } from '@angular/core';
import { BaseBusinessManagement } from '../../baseBusinessManagement';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app-state.index';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-business-management-mobile',
  templateUrl: './business-management-mobile.component.html',
  styleUrl: './business-management-mobile.component.scss'
})
export class BusinessManagementMobileComponent  extends BaseBusinessManagement implements OnInit {
  constructor(public localizationService: LocalizationService,
             public store:Store<AppState>,
            public commonService: CommonService,
            public businessManagment:BusinessManagmentService,
                       public router: Router,
) {
  super(localizationService,store,commonService,businessManagment,router)
}
override numRowsInPage = 50;
  ngOnInit(): void {
      this.init()
      this.loadBusinessRoulettes()
  }
displaySidebar:boolean=false
  onPageChange(event: any) {
    const pageNo = event.page + 1;
    this.createRequest(pageNo);
  }
  
  onBusinessClick(business: any) {
    this.router.navigate(['webplatform', 'business-details', business.BusinessId]);
  }
}
